import React ,{useState , useEffect}from "react";
import CommonSelect from "../common/commonSelect";
import Select from "react-select";
import { useSelector , useDispatch } from 'react-redux';
import { AppDispatch } from '../../core/data/redux/store';
import { createGoaltype ,fetchAllGoaltype } from "../data/redux/performance/goaltype/goaltypeAction";
import { Drawer, message } from "antd";
interface GoalTypeForm {
  Goaltype: string;
  Description: string;
  Status: { value: string; label: string };
}

interface GoaltypeModalProps {
  visible: boolean;
  onClose: () => void;
}

const statusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

const GoalTypeModal : React.FC<GoaltypeModalProps> = ({ visible, onClose }) => {

 const { user } = useSelector((state: any) => state.auth);
  const dispatch = useDispatch<AppDispatch>();
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const [formData, setFormData] = useState<any>({
    Goaltype: "",
    Description: "",
    Status: statusOptions[0], 
    createdBy : user?.UserId
  });
 const [errors, setErrors] = useState<any>({});
 
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev : any) => ({ ...prev, [name]: value }));
  };

  
  const handleSelectChange = (selectedOption: { value: string; label: string } | null) => {
    if (selectedOption) {
      setFormData((prev: any) => ({ ...prev, Status: selectedOption }));
    }
  };


  const validateForm = () => {
    let formIsValid = true;
  
    let newErrors: any = {
      Goaltype: '',
      Description: '',
      Status: '',
    };
  
    if (!formData.Goaltype) {
      formIsValid = false;
      newErrors.Goaltype = 'Goal Type is required.';
    }
  

  
    if (!formData.Status || formData.Status.value === 'Select') {
      formIsValid = false;
      newErrors.Status = 'Status is required.';
    }
  
    setErrors(newErrors);
    return formIsValid;
  };
  

 
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  
    if (!validateForm()) return;

    const submissionData = {
      ...formData,
      Status: formData.Status.value, 
    };
  
    dispatch(createGoaltype(submissionData))
      .then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          setTimeout(() => {
            message.success(res.payload.message);
          }, 1000);
  
          setFormData({
            Goaltype: "",
            Description: "",
            Status: statusOptions[0], 
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          message.warning(res.payload.message);
        }
      });
  };
  
  return (
    <>
      <Drawer
          title="Add Goal type"
          placement="right"
          onClose={onClose}
          open={visible}
          width={480}
          style={{ marginTop: 50 }}
        >
          <form onSubmit={handleSubmit}>
            <div className="modal-body pb-0">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Goal Type <span className="text-danger"> *</span></label>
                    <input
                      type="text"
                      name="Goaltype"
                      className="form-control"
                      value={formData.Goaltype}
                      onChange={handleChange}
                      
                    />
                    {errors.Goaltype && <div style={{ color: "red" }}>{errors.Goaltype}</div>}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Status <span className="text-danger"> *</span></label>
                    <Select
                      className="select"
                      options={statusOptions}
                      value={formData.Status}
                      onChange={handleSelectChange}
                    />
                     {errors.Status && <div style={{ color: "red" }}>{errors.Status}</div>}
                  </div>
                </div>
                 <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                      name="Description"
                      className="form-control"
                      value={formData.Description}
                      onChange={handleChange}
                    />
                     {errors.Description && <div style={{ color: "red" }}>{errors.Description}</div>}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-light me-2" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Add Goal Type
              </button>
            </div>
          </form>
       </Drawer>
     
    </>
  );
};

export default GoalTypeModal;
